import { render } from "./goods.vue?vue&type=template&id=ec58d7a4&scoped=true&ts=true"
import script from "./goods.vue?vue&type=script&lang=ts"
export * from "./goods.vue?vue&type=script&lang=ts"

import "./goods.vue?vue&type=style&index=0&id=ec58d7a4&lang=css"
import "./goods.vue?vue&type=style&index=1&id=ec58d7a4&lang=less&scoped=true"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec58d7a4"]])

export default __exports__